import * as React from 'react'
import { MapPin } from 'react-feather'

import { ExternalSchool_externalSchool_address } from 'main/gql/externalSchool'
import { SchoolPage_school_address } from 'main/pages/School/gql'
import { Text } from 'main/ui'
import { formatAddress } from 'main/util/address'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../common'
import { i18nKeyPrefix } from '../../../pages/School/i18n'
import { Bullet, InfoSection } from '../common'
import Map from './Map'

const PRE = `${i18nKeyPrefix}-LOCATION`

interface IProps {
  address: ExternalSchool_externalSchool_address | SchoolPage_school_address
  fuzzy: boolean
}

export default function Location(props: IProps) {
  const { address, fuzzy } = props
  const { latitude, longitude } = address

  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <InfoSection title={t(`${PRE}-TITLE`)}>
      <Bullet icon={<MapPin />}>
        <Text>{formatAddress(address, fuzzy)}</Text>
      </Bullet>
      {latitude !== null && longitude !== null ? <Map {...{ latitude, longitude }} /> : null}
    </InfoSection>
  )
}

Location.defaultProps = {
  fuzzy: true,
}
